import api from "./api";

export const changePassword = async (data: any) => {
  const res = await api.put("/auth/change-password", data);
  return res.data;
};
